import { get, post, put, destroy } from '@/api/request';

function fetchInvoices(params = {}) {
  return get('/invoices', params);
}

function createInvoice(data) {
  return post('/invoices', data);
}

function updateInvoice({ id, data }) {
  return put(`/invoices/${id}`, data);
}

function deleteInvoice(id) {
  return destroy(`/invoices/${id}`);
}

export default {
  fetchInvoices,
  createInvoice,
  updateInvoice,
  deleteInvoice,
};



// WEBPACK FOOTER //
// ./src/store/modules/invoice/api.js